<template>
	<div>
		<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/D.png" style="width: 100%;"/>
		<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/welcome/D1.png" style="width: 100%;"/>
		<br /><br />
		<div style="width: 90%;margin: auto;">
			<h2>
				{{ $t('lang.Receptionist')}}{{ $t('lang.Robot')}}
			</h2>
		
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/Ua.png" />
			<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/welcome/Ua1.png" />
			
			<hr />
			<h2>{{ $t('lang.Video_introduction')}}</h2>
			
			<video width="100%" controls>
				<source src="../../../public/pic/product/welcome/YBEN2.mp4" type="video/mp4">
				您的浏览器不支持 video 标签。
			</video>
		
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/1.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/2.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/3.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/4.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/5.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/6.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/7.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/8.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/9.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/10.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/11.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/12.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/13.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/14.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/15.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/16.png" />
			
			<hr />
			<h2>{{ $t('lang.welcome1')}}</h2>
			
			<table border="5" style="border-collapse: collapse; width:100%;">
				<tr>
					<td class="black" ><span>{{ $t('lang.welcome2')}}</span> </td>
					<td class="black"><span>{{ $t('lang.welcome3')}}</span></td>
				</tr>
				<tr>
					<td class="black " ><span>{{ $t('lang.welcome4')}}</span></td>
					<td class="black "><span>{{ $t('lang.welcome5')}}</span></td>
				</tr>
				<tr>
					<td class="black " ><span>{{ $t('lang.welcome6')}}</span></td>
					<td class="black "><span>{{ $t('lang.welcome7')}}</span></td>
				</tr>
				<tr>
					<td class="black" ><span>{{ $t('lang.welcome8')}}</span></td>
					<td class="black"><span>{{ $t('lang.welcome9')}}</span></td>
				</tr>
				<tr>
					<td class="black" ><span>{{ $t('lang.welcome10')}}</span></td>
					<td class="black"><span>{{ $t('lang.welcome11')}}</span></td>
				</tr>
				<tr>
					<td class="black" ><span>{{ $t('lang.welcome12')}}</span></td>
					<td class="black"><span>{{ $t('lang.welcome13')}}</span></td>
				</tr>
				<tr>
					<td class="black" ><span>{{ $t('lang.welcome4')}}</span></td>
					<td class="black"><span>{{ $t('lang.welcome15')}}</span></td>
				</tr>
				<tr>
					<td class="black" ><span>{{ $t('lang.welcome6')}}</span></td>
					<td class="black"><span>{{ $t('lang.welcome7')}}</span></td>
				</tr>
				<tr>
					<td class="black" ><span>{{ $t('lang.welcome18')}}</span></td>
					<td class="black"><span>{{ $t('lang.welcome19')}}</span></td>
				</tr>
				<tr>
					<td class="black" ><span>{{ $t('lang.welcome20')}}</span></td>
					<td class="black"><span>{{ $t('lang.welcome21')}}</span></td>
				</tr>
				<tr>
					<td class="black" ><span>{{ $t('lang.welcome22')}}</span></td>
					<td class="black"><span>{{ $t('lang.welcome23')}}</span></td>
				</tr>
			</table>
			
			<hr />
			<h2>{{ $t('lang.uvc_p2')}}</h2>
			
			<el-row>
				<el-col :span="12"><img src="../../../public/pic/product/welcome/yinbingC.png" /></el-col>
				<el-col :span="12"><img style="margin-top: 20px;" src="../../../public/pic/product/welcome/yinbingD.png" /></el-col>
			</el-row>
			
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '迎宾机器人_深圳全智能机器人科技有限公司。 waiter robot  _Shenzhen all intelligent robot technology Co., Ltd',
			keywords : '迎宾机器人,仿真机器人,人形机器人,讲解机器人,导购机器人, 商务机器人,智能商业迎宾机器人，智能迎宾机器人报价 。welcoming robot,humanoid robot,anthropomorphic robot,broadcasting robot, Shopping guide robot,business robot,Intelligent business welcome robot,Intelligent welcoming robot quote',
			description : '深圳全智能机器人科技有限公司研发生产的迎宾机器人，1比1仿真人设计，内置仿真骨骼，身体皮肤清晰可见,手感光滑细腻。礼貌迎宾+自由讲解+人机交互+自定义内容。支持二次开发，提供SDK接口。全智能（TPE）仿真迎宾讲解机器人，可自主深入学习。The welcoming robot developed and produced by Shenzhen all intelligent robot technology Co., Ltd. is 1:1 bionic real person design, with built-in simulation skeleton, the body skin is clearly visible, and the hand feeling is smooth and delicate. Polite welcome + FREE explanation + human-computer interaction + custom content. it support secondary development, provide SDK web interfaces.The fully intelligent (TPE) simulation robot can learn deeply and autonomously',
		};
	},
}
</script>

<style scoped>
	img{
		width: 100%;
	}
	p{
		color: white;
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}

	
	td{
		width: 50%;
	}
</style>
